<flowaccount-e-tax-invoice-intro></flowaccount-e-tax-invoice-intro>

<flowaccount-e-tax-invoice-scoreboard></flowaccount-e-tax-invoice-scoreboard>

<flowaccount-tax-invoice-banner-shared
  [contentList]="mockContent"
  [customClass]="'e-tax-invoice-by-email'"
></flowaccount-tax-invoice-banner-shared>

<flowaccount-e-tax-invoice-send-and-scan></flowaccount-e-tax-invoice-send-and-scan>

<flowaccount-blog-swiper-squidex
  [customHeader]="customHeader"
  [lang]="translate.currentLang"
  [contentSquidex]="'e-tax-invoice-by-email-blog'"
  [contentScully]="'e-tax-invoice-by-email-blog-key'"
></flowaccount-blog-swiper-squidex>

<flowaccount-e-tax-invoice-cta></flowaccount-e-tax-invoice-cta>
